<template>
  <div class="home">
    <div class="home__head">
      <div class="navbar navbar-expand-lg"
        style="position: fixed; top: 0; width: 100%; z-index: 1000; background-color: #fff; padding: 0; box-shadow: 0px 4px 16px 0px rgba(69, 74, 108, 0.08) !important;">
        <div class="container">
          <router-link :to="{ name: 'home' }" class="navbar-brand">
            <!-- <img :src="require('@/assets/images/app/logo-Inter.png')" loading="lazy" alt="" /> -->
            <img style="width: 220px; height: auto" :src="require('@/assets/images/app/logos-Inter.png')" loading="lazy"
              alt="" />
          </router-link>

          <button class="navbar-toggler" type="button" v-b-toggle.nav-head>
            <!-- <span class="navbar-toggler-icon"></span> -->
            <!-- <i class="fas fa-bars"></i> -->
            <img :src="require('@/assets/images/app/Menu.png')" alt="" />
          </button>
          <b-collapse class="collapse navbar-collapse" id="nav-head">
            <ul class="navbar-nav ms-auto" style="z-index: 1000">
              <!-- <li class="nav-item">
                <a :href="'#savings'" class="nav-link">¿Cómo funciona?</a>
              </li>
              <li class="nav-item">
                <a :href="'#testimonials'" class="nav-link">Testimonios</a>
              </li> -->
              <li class="nav-item">
                <a :href="'#faq'" class="nav-link-questions">Preguntas Frecuentes</a>
              </li>
              <li class="nav-item">
                <a href="#" class="nav-link nav-btn" v-b-modal.login-modal @click="saveLoginEvent()"
                  style="padding: 5px 9px 5px 9px">Zona cliente</a>
              </li>
            </ul>
          </b-collapse>
        </div>
      </div>
    </div>
    <!-- 
    ====================BANNER-DESKTOP==================================== -->
    <div class="carousel-content hidden-mobile">
      <div class="carousel-content__form">
        <div class="home__quote-card card-slider w-50">
          <div class="cuadro d-flex align-items-center justify-content-center">
            <span class="desde">desde </span>
            <span class="quantity"> S/160</span>
          </div>
          <form action="#">
            <div class="d-flex justify-content-start"></div>
            <div class="pb-4 pt-4">
              <span style="font-size: 16px; color: #454a6c; text-align: left">
                ¿Quieres probar cuánto ganarías con Rumbo?
              </span>
            </div>
            <div class="form-group d-block" :class="{
              invalid:
                this.v$.userInfo.identificationNumber.$error &&
                flags.showError,
            }">
              <input type="text" placeholder="Ingresa tu DNI/CE" class="form-control input-place" style="
                  text-align: center !important;
                  border: 1px solid var(--neutral-color-medium, #a1a5c4);
                " v-model="this.v$.userInfo.identificationNumber.$model" :minlength="documentLength"
                :maxlength="documentLength" @keypress="validateInput($event)" @keyup="redirectToQuote()"
                @blur="flags.showError = true" />
              <div v-if="this.v$.userInfo.identificationNumber.$error &&
                flags.showError
                ">
                <span :class="{
                  error: this.v$.userInfo.identificationNumber.$error,
                }">Ingrese un número de documento v&aacute;lido</span>
              </div>
            </div>
            <div class="form-group">
              <button type="submit" class="form-btn" :disabled="flags.searching">
                <span v-if="!flags.searching">COTIZAR AHORA</span>
                <i class="fas fa-circle-notch fa-spin" v-if="flags.searching"></i>
              </button>
            </div>
            <div class="form-group">
              <span>Al cotizar acepto la
                <a href="https://documentos.interseguro.com.pe/PDF/PoliticaPrivacidadInterseguro-1810.pdf"
                  target="_blank">política de privacidad</a></span>
            </div>
          </form>
        </div>
      </div>
      <carousel :margin="0" :dots="false" :nav="true" :items="1" :loop="true" :autoplay="true"
        v-bind:autoplay-timeout="6000" class="home__banner__carousel">
        <div class="home__banner__carousel__slider3">
          <div class="home__banner__carousel__slider3__text">
            <span class="ahorro">Ahorra todos los meses</span>
            <h6 class="maestria mb-0" style="margin-bottom: -2px">
              para tu DEPA
            </h6>
            <span class="hasta">hasta</span>
            <div class="d-flex align-items-center" style="margin-top: -16px">
              <span class="number">8.1</span>
              <span class="porcent pt-3">%</span>
              <span class="trea pt-3">TREA</span>
            </div>
          </div>
          <div class="home__banner__carousel__slider3__promo"></div>
        </div>

        <div class="home__banner__carousel__slider2">
          <div class="home__banner__carousel__slider2__text">
            <span class="ahorro">Ahorra todos los meses</span>
            <h6 class="maestria" style="margin-bottom: -2px">
              para tu NEGOCIO propio
            </h6>
            <span class="hasta">hasta</span>
            <div class="d-flex align-items-center" style="margin-top: -16px">
              <span class="number">8.1</span>
              <span class="porcent pt-3">%</span>
              <span class="trea pt-3">TREA</span>
            </div>
          </div>
        </div>

        <div class="home__banner__carousel__slider1">
          <div class="home__banner__carousel__slider1__text">
            <span class="ahorro">Ahorra todos los meses</span>
            <h6 class="maestria" style="margin-bottom: -2px">
              para tu MAESTRÍA
            </h6>
            <span class="hasta">hasta</span>
            <div class="d-flex align-items-center" style="margin-top: -16px">
              <span class="number">8.1</span>
              <span class="porcent pt-3">%</span>
              <span class="trea pt-3">TREA</span>
            </div>
          </div>
        </div>
      </carousel>
    </div>

    <!-- =========================BANNER-MOBILE========================= -->
    <!--div-- class="home__banner-sorteo visible-mobile">
      <a href="https://docs.google.com/document/d/1pp31DLK4HY2Fr6SWgzM0UhE161J2krYRk4dOe9OIWA0/edit"
        target="_blank">
        <div class="contenedor">
          <img :src="require('@/assets/images/app/navidad_mobile.png')" alt="" />
        </div>
      </a>
    </div-->
    <div class="carousel-content-mobile visible-mobile" style="padding-top: 60px">
      <!--div class="carousel-content-mobile visible-mobile"-->
      <carousel :margin="0" :dots="false" :nav="false" :items="1" :loop="true" :autoplay="true"
        v-bind:autoplay-timeout="6000" class="home__banner__carousel">
        <div>
          <div class="home__banner__newBanner visible-mobile">
            <div class="home__banner__newBanner__text">
              <span class="ahorro">Ahorra todos los meses</span>
              <h6 class="maestria mb-0">para tu DEPA</h6>
              <span class="hasta1">hasta</span>
              <div class="home__banner__newBanner__text__content-trea-depa d-flex">
                <span class="number">8.1%</span>
                <span class="trea pt-3">TREA</span>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="home__banner__newBanner2 visible-mobile">
            <div class="home__banner__newBanner2__text">
              <span class="ahorro">Ahorra todos los meses</span>
              <h6 class="maestria mb-0">para tu NEGOCIO</h6>
              <h6 class="maestria mb-0">propio</h6>
              <span class="hasta">hasta</span>
              <div class="home__banner__newBanner2__text__content-trea d-flex">
                <span class="number">8.1%</span>
                <span class="trea pt-3">TREA</span>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="home__banner__newBanner3 visible-mobile">
            <div class="home__banner__newBanner3__text">
              <span class="ahorro">Ahorra todos los meses</span>
              <h6 class="maestria mb-0">para tu MAESTRÍA</h6>
              <span class="hasta2">hasta</span>
              <div class="home__banner__newBanner3__text__content-trea-maestria d-flex">
                <span class="number">8.1%</span>
                <span class="trea pt-3">TREA</span>
              </div>
            </div>
          </div>
        </div>
      </carousel>
      <div class="container">
        <div class="home__quote-card">
          <div class="cuadro d-flex align-items-center justify-content-center">
            <span class="desde">desde </span>
            <span class="quantity"> S/160</span>
          </div>
          <form action="#">
            <div class="pb-2">
              <span style="font-size: 16px; color: #454a6c; text-align: left">
                ¿Quieres probar cuánto ganarías con Rumbo?
              </span>
            </div>
            <div class="form-group d-block" :class="{
              invalid:
                this.v$.userInfo.identificationNumber.$error &&
                flags.showError,
            }">
              <input type="text" placeholder="Ingresa tu DNI/CE" class="form-control input-place" style="
                  text-align: center !important;
                  border: 1px solid var(--neutral-color-medium, #a1a5c4);
                " v-model="this.v$.userInfo.identificationNumber.$model" :minlength="documentLength"
                :maxlength="documentLength" @keypress="validateInput($event)" @keyup="redirectToQuote()"
                @blur="flags.showError = true" />
              <div v-if="this.v$.userInfo.identificationNumber.$error &&
                flags.showError
                ">
                <span :class="{
                  error: this.v$.userInfo.identificationNumber.$error,
                }">Ingrese un número de documento v&aacute;lido</span>
              </div>
            </div>
            <div class="form-group">
              <button type="submit" class="form-btn" :disabled="flags.searching">
                <span v-if="!flags.searching">COTIZAR AHORA</span>
                <i class="fas fa-circle-notch fa-spin" v-if="flags.searching"></i>
              </button>
            </div>
            <div class="form-group">
              <span>Al cotizar acepto la
                <a href="https://documentos.interseguro.com.pe/PDF/PoliticaPrivacidadInterseguro-1810.pdf"
                  target="_blank">política de privacidad</a></span>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!--div-- class="home__banner-sorteo hidden-mobile">
      <a href="https://docs.google.com/document/d/1pp31DLK4HY2Fr6SWgzM0UhE161J2krYRk4dOe9OIWA0/edit"
        target="_blank">
        <div class="contenedor">
          <img :src="require('@/assets/images/app/navidad_desktop.png')">
        </div>
      </a>
    </div-->
    <!--<br>-->
    <router-link :to="{ name: 'tyc' }" target="_blank">
      <div class="custom-cintillo-background">
        <div class="custom-cintillo-container">
          <div class="custom-cintillo">
            <img class="custom-cintillo__cintillo custom-cintillo--desktop" src="@/assets/cintillo/promo-abril/cintillo-desktop.png" alt="cintillo-desktop"/>
            <img class="custom-cintillo__cintillo custom-cintillo--mobile" src="@/assets/cintillo/promo-abril/cintillo-mobile.png" alt="cintillo-mobile"/>
          </div>
        </div>
      </div>
    </router-link>
    <div class="home__section-benefits">
      <div class="container">
        <h2 style="padding: 35px 0px 40px 0px !important">
          Ahorra sin miedos y con la libertad que tú pediste
        </h2>
        <div class="row">
          <div class="col-sm-5"></div>
          <div class="col-sm">
            <!-- <div class="home__section-benefits__title">
                            <img :src="require('@/assets/images/app/shield-user.png')" alt="">
                            <span>En caso de fallecimiento, cuentas con un seguro de vida</span>
                        </div> -->
            <!-- <span class="home__section-benefits__separator"></span> -->
            <div class="row">
              <div class="col-sm">
                <div class="home__section-benefits__benefit">
                  <div class="benefit-img">
                    <img :src="require('@/assets/images/app/check-green.png')" alt="" />
                  </div>
                  <span>Congela tu cuenta por un tiempo si no puedes continuar con
                    tu aporte</span>
                </div>
              </div>
              <div class="col-sm">
                <div class="home__section-benefits__benefit">
                  <div class="benefit-img">
                    <img :src="require('@/assets/images/app/check-green.png')" alt="" />
                  </div>
                  <span>Adquiere más de un plan en simultáneo</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm">
                <div class="home__section-benefits__benefit">
                  <div class="benefit-img">
                    <img :src="require('@/assets/images/app/check-green.png')" alt="" />
                  </div>
                  <span>Sube o baja tu monto de ahorro mensual</span>
                </div>
              </div>
            </div>
            <!-- <div class="d-flex justify-content-center w-100">
                            <button href="#startQuote" class="home__section-benefits__btn">¡Lo quiero!</button>
                        </div> -->

            <div class="d-flex justify-content-center w-100">
              <a href="#startQuote" class="home__section-benefits__btn">¡Lo quiero!</a>
            </div>

            <!-- <span class="home__section-benefits__note">En caso de fallecimiento, tus familiares estarán
                            protegidos por S/25,000</span> -->
            <div class="home__section-benefits__title mt-5">
              <img :src="require('@/assets/images/app/shield-user.png')" alt="" />
              <span>En caso de fallecimiento, cuentas con un seguro de vida por
                S/25,000</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home__section-savings" id="savings">
      <div class="container">
        <h2>
          Conoce cómo María ahorra para <br />
          cumplir su meta y proteger a los que ama
        </h2>

        <div class="home__section-savings__image">
          <img :src="require('@/assets/images/app/Story-desktop.png')" alt="" />
          <img :src="require('@/assets/images/app/Story-mobile.png')" alt="" />
        </div>

        <a :href="pdfPath"
           target="_blank">
          <div class="custom-folleto-background">
            <div class="custom-cintillo-container">
              <div class="custom-cintillo">
                <img class="custom-cintillo__cintillo custom-cintillo--desktop" :src="require('@/assets/images/app/folleto/folleto_desktop.png')" alt="folleto"/>
                <img class="custom-cintillo__cintillo custom-cintillo--mobile" :src="require('@/assets/images/app/folleto/folleto_mobile.png')" alt="folleto"/>
              </div>
            </div>
          </div>
        </a>

        <div class="hidden-mobile">
          <div class="mb-5 mt-5">
            <img src="@/assets/images/app/logos-png.png" alt="" class="w-100" />
          </div>
        </div>

        <div class="visible-mobile">
          <div class="somosParteDe">
            <div class="somosParteDe__logo">
              <img src="@/assets/images/app/somospartede.png" alt="" />
            </div>
          </div>
          <div class="Logos">
            <div class="Logos__content">
              <div class="interbank">
                <img src="@/assets/images/app/interbank.png" alt="" />
              </div>
            </div>
            <div class="Logos__content">
              <div class="interseguro">
                <img src="@/assets/images/app/interseguro.png" alt="" />
              </div>
            </div>
            <div class="Logos__content">
              <div class="frame">
                <img src="@/assets/images/app/Frame.png" alt="" />
              </div>
            </div>
            <div class="Logos__content">
              <div class="plazavea">
                <img src="@/assets/images/app/plazavea.png" alt="" />
              </div>
            </div>
            <div class="Logos__content">
              <div class="financieraoh">
                <img src="@/assets/images/app/financieraoh.png" alt="" />
              </div>
            </div>
            <div class="Logos__content">
              <div class="promart">
                <img src="@/assets/images/app/promart.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home__section-quote">
      <div class="container">
        <h2>Cotiza y compra en segundos</h2>
        <div class="row">
          <div class="col-sm-5">
            <ul class="home__section-quote__steps">
              <li>
                <div class="home__section-quote__steps__img">
                  <img :src="require('@/assets/images/app/paso-1.png')" alt="" />
                </div>
                <div class="home__section-quote__steps__text">
                  <span>Paso 1</span>
                  <p>Ingresa tu DNI</p>
                </div>
              </li>
              <li>
                <div class="home__section-quote__steps__img">
                  <img :src="require('@/assets/images/app/paso-2.png')" alt="" />
                </div>
                <div class="home__section-quote__steps__text">
                  <span>Paso 2</span>
                  <p>Llena tus datos</p>
                </div>
              </li>
              <li>
                <div class="home__section-quote__steps__img">
                  <img :src="require('@/assets/images/app/paso-3.png')" alt="" />
                </div>
                <div class="home__section-quote__steps__text">
                  <span>Paso 3</span>
                  <p>Elige cuánto ahorrar y por cuánto tiempo</p>
                </div>
              </li>
              <li>
                <div class="home__section-quote__steps__img">
                  <img :src="require('@/assets/images/app/paso-4.png')" alt="" />
                </div>
                <div class="home__section-quote__steps__text">
                  <span>Paso 4</span>
                  <p>Confirma tu compra</p>
                </div>
              </li>
            </ul>
            <span class="home__section-quote__note">¡Listo, ya estás haciendo crecer tu dinero!</span>
          </div>
          <div class="col-sm d-flex justify-content-center">
            <div class="home__section-quote__gif">
              <img :src="require('@/assets/images/app/gif-28-02.gif')" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="home__banner-sorteo hidden-mobile">
      <a href="https://www.interseguro.pe/vivemas/beneficios?product=rumbo" target="_blank">
        <div class="contenedor">
          <img :src="require('@/assets/images/app/vivemas.svg')" alt="vivemas" width="100%" />
        </div>
      </a>
    </div>
    <div class="home__banner-sorteo visible-mobile">
      <a href="https://www.interseguro.pe/vivemas/beneficios?product=rumbo" target="_blank">
        <div class="contenedor">
          <img :src="require('@/assets/images/app/vivemas_mobile.svg')" alt="vivemas" />
        </div>
      </a>
    </div>

    <div class="home__section-feedback" id="testimonials">
      <div class="container">
        <h2>¡Ellos ya protegen a quienes más aman!</h2>
        <carousel :margin="0" :dots="true" :nav="false" :items="carouselItems" :loop="true" :autoplay="true"
          v-bind:autoplay-timeout="2000" v-if="carouselItems > 0">
          <div class="home__section-feedback__card">
            <div class="home__section-feedback__card__head">
              <img :src="require('@/assets/images/app/c-1.png')" loading="lazy" alt="" />
            </div>
            <div class="home__section-feedback__card__body">
              <span>
                “Empezar a ahorrar con Rumbo fue muy fácil, a diferencia de
                otras aseguradoras. Además, lo pude hacer sola sin trámites
                complicados”.
              </span>
            </div>
            <div class="home__section-feedback__card__footer">
              <p>
                Ivana <br />
                Arequipa, Peru
              </p>
            </div>
          </div>
          <div class="home__section-feedback__card">
            <div class="home__section-feedback__card__head">
              <img :src="require('@/assets/images/app/c-2.png')" loading="lazy" alt="" />
            </div>
            <div class="home__section-feedback__card__body">
              <span>
                “Lo interesante de Rumbo es que es digital y fácil de usar, lo
                puedo hacer desde mi casa”.
              </span>
            </div>
            <div class="home__section-feedback__card__footer">
              <p>
                David <br />
                Lima, Peru
              </p>
            </div>
          </div>
          <div class="home__section-feedback__card">
            <div class="home__section-feedback__card__head">
              <img :src="require('@/assets/images/app/c-3.png')" loading="lazy" alt="" />
            </div>
            <div class="home__section-feedback__card__body">
              <span>
                “Me gusta que pueda reducir mis aportes o congelar mi plan ante
                cualquier emergencia”.
              </span>
            </div>
            <div class="home__section-feedback__card__footer">
              <p>
                Johana <br />
                Piura, Peru
              </p>
            </div>
          </div>
        </carousel>
      </div>
    </div>

    <div class="home__section-faq" id="faq">
      <h2>Preguntas frecuentes</h2>
      <div class="container">
        <div class="home__section-faq__list">
          <div class="home__section-faq__card" v-for="f of faq" :class="{ open: f.show }" v-bind:key="'faq-' + f.id">
            <span @click="f.show = !f.show">{{ f.question }}</span>
            <p v-show="f.show">{{ f.answer }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="home__section-subscribe">
      <div class="container">
        <form action="#" @submit="saveLead($event)">
          <div class="form-group" :class="{ invalid: this.v$.lead.email.$error }">
            <input type="text" class="form-control" placeholder="Ingresa tu correo electronico"
              v-model="this.v$.lead.email.$model" />
            <button type="submit" class="form-btn" :disabled="flags.savingLead">
              <span v-if="!flags.savingLead">¡Quiero más información!</span>
              <i class="fas fa-circle-notch fa-spin" v-if="flags.savingLead"></i>
            </button>
          </div>
        </form>
        <div class="home__section-subscribe__success" v-if="flags.savedLead">
          <span>Gracias. Nos pondremos en contacto contigo a la brevedad!</span>
        </div>
      </div>
    </div>

    <!--a class="imagen-button promocion hidden-mobile" id="chatButton" target="_blank" href="https://www.interseguro.pe/seguro-de-vida/rumbo/tyc">
      <img :src="require('@/assets/images/app/pasaje_cusco.png')" alt="" width="180" loading="lazy" />
    </a-->

    <a class="imagen-button folleto hidden-mobile" id="chatButton" target="_blank" :href="pdfPath">
      <img :src="require('@/assets/images/app/folleto/flotante_desktop.png')" alt="" width="180" loading="lazy" />
    </a>
    <a class="imagen-button folleto visible-mobile" id="chatButton" target="_blank" :href="pdfPath">
      <img :src="require('@/assets/images/app/folleto/flotante_mobile.png')" alt="" width="180" loading="lazy" />
    </a>

    <a class="chat-button phone" id="chatButton" target="_blank" href="tel:016149288999" @click="openWapp()">
      <img :src="require('@/assets/images/app/newWpp.png')" alt="" width="160" loading="lazy" />
      <div class="chat-button__label visible-mobile">
        Llámanos
      </div>
      <div class="chat-button__label hidden-mobile">
        Llámanos al (01) 614-9288
      </div>
    </a>
    <a class="chat-button hidden-mobile" id="chatButton" target="_blank"
      href="https://api.whatsapp.com/send?phone=51946523076&text=Hola%2C%20Rumbo.%20%C2%A1Deseo%20m%C3%A1s%20informaci%C3%B3n!"
      @click="openWapp()">
      <img :src="require('@/assets/images/app/wapp-chat.svg')" alt="" width="160" loading="lazy" />
      <div class="chat-button__label">
        Comunícate con un asesor vía WhatsApp
      </div>
    </a>
    <div class="home__footer">
      <div class="container">
        <div class="row">
          <div class="col-sm-8">
            <div class="home__footer__RUC">
              <div class="hidden-mobile">
                <p>RUC 20382748566</p>
                <p>INTERSEGURO COMPAÑIA DE SEGUROS S. A. </p>
              </div>
            </div>
            <div class="home__footer__RUC">
              <div class="visible-mobile">
                <label>RUC 20382748566</label>
                <label>INTERSEGURO COMPAÑIA DE SEGUROS S. A.</label>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="home__footer__logo">
              <div class="hidden-mobile">
                <img :src="require('@/assets/images/app/is-white.png')" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="container">
        <div class="row">
          <div class="col-sm-8">
            <div class="home__footer__section">
              <router-link :to="{ name: 'tyc' }" target="_blank" class="col-xs-12 col-sm-12 col-md-6">
                Promociones
              </router-link>
              <a class="col-xs-12 col-sm-12 col-md-6"
                href="https://drive.google.com/file/d/1Iee2iwNq7gmq_KHPPIqoHScz9vTh0rPw/view?usp=sharing" target="_blank">
                Condicionado General
              </a>
              <a class="col-xs-12 col-sm-12 col-md-6"
                href="https://drive.google.com/file/d/169z7Wg8ipBG5Itc2ZJlUmVNAiAq36kIt/view?usp=sharing" target="_blank">
                Condicionado Particular
              </a>
              <a class="col-xs-12 col-sm-12 col-md-6" href="mailto:rumbo@interseguro.com.pe">
                <span>rumbo@interseguro.com.pe</span>
              </a>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="home__footer__logo">
              <div class="hidden-mobile">
                <a href="https://app.interseguro.com.pe/LibroReclamaciones/" target="_blank">
                  <img class="libro" :src="require('@/assets/images/app/libro_ant.svg')" alt="" />
                </a>
              </div>
            </div>
            <div class="home__footer__logo">
              <div class="visible-mobile">
                <a href="https://app.interseguro.com.pe/LibroReclamaciones/" target="_blank">
                  <img class="libro" :src="require('@/assets/images/app/libro_ant2.svg')" alt="" />
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <b-modal id="login-modal" ok-only centered size="sm" modal-class="login-modal" title="Zona Cliente" ref="login-modal">
      <div class="quote-card">
        <form action="#" v-if="!flags.validateOtp" @submit="sendOtp">
          <div class="d-flex justify-content-start">
            <div class="form-group type-radio">
              <input type="radio" id="client-dni" name="client-doc" v-model="this.v$.login.identificationType.$model"
                value="dni" @change="setDocumentLength()" checked />
              <label for="client-dni">DNI</label>
            </div>
            <div class="form-group type-radio">
              <input type="radio" name="client-doc" id="client-ce" v-model="this.v$.login.identificationType.$model"
                value="ce" @change="setDocumentLength()" />
              <label for="client-ce">CE</label>
            </div>
          </div>
          <div class="form-group d-block" :class="{ invalid: this.v$.login.identificationNumber.$error }">
            <input type="text" placeholder="Digita tu número de documento" class="form-control"
              v-model="this.v$.login.identificationNumber.$model" @keypress="validateInput($event)" />
            <div v-if="this.v$.login.identificationNumber.$error && flags.showError
              ">
              <span :class="{ error: this.v$.login.identificationNumber.$error }">Ingrese un número de documento
                v&aacute;lido</span>
            </div>
          </div>
          <div class="form-group">
            <button type="submit" class="form-btn" :disabled="flags.logingIn">
              <span v-if="!flags.logingIn">Continuar</span>
              <i class="fas fa-circle-notch fa-spin" v-if="flags.logingIn"></i>
            </button>
          </div>
        </form>
        <form action="#" v-if="flags.validateOtp" @submit="validateOtp">
          <div class="form-group">
            <label label for="" style="position: initial">Ingresa el c&oacute;digo enviado al correo {{ otp.email
            }}</label>
          </div>
          <div class="form-group d-block" :class="{ invalid: this.v$.login.identificationNumber.$error }">
            <input type="text" placeholder="Codigo de autenticación" class="form-control"
              v-model="this.v$.otpCode.code.$model" />
            <div v-if="this.v$.userInfo.identificationNumber.$error && flags.showError
              ">
              <span :class="{ error: this.v$.login.identificationNumber.$error }">Ingrese un c&oacute;digo
                v&aacute;lido</span>
            </div>
          </div>
          <div class="form-group">
            <button type="submit" class="form-btn" :disabled="flags.logingIn">
              <span v-if="!flags.logingIn">Validar</span>
              <i class="fas fa-circle-notch fa-spin" v-if="flags.logingIn"></i>
            </button>
          </div>
        </form>
      </div>
    </b-modal>

    <b-modal id="modal-no-insurance" ok-only ok-title="Entiendo" centered modal-class="modal-no-insurance"
      ref="modal-no-insurance">
      <div class="modal-no-insurance__head">
        <h3>
          ¡Ya cuentas con un seguro
          <br />
          de vida con devolucion!
        </h3>
        <p>Para más información puedes comunicarte con nuestro WhatsApp</p>
      </div>
      <div class="d-flex justify-content-center">
        <button @click="closeModalNoInsurance()">Aceptar</button>
      </div>
    </b-modal>

    <b-modal id="modal-cookies" ok-only ok-title="" centered modal-class="cookies" ref="modal-cookies">
      <div class="cookies__head">
        <span class="cookies__head__title">Configuración de cookies</span>
        <p>
          Este sitio web utiliza cookies para mejorar tu experiencia de
          navegación y para mostrarte publicidad relevante. Las cookies son
          pequeños archivos de texto que se almacenan en tu dispositivo cuando
          visitas un sitio web.
        </p>
        <p>
          Estos archivos permiten entender el comportamiento del usuario en la
          web, recordar detalles de acceso y preferencias de navegación. Sin
          embargo, el bloqueo de algunas cookies puede afectar la experiencia
          del usuario en el sitio web y los servicios ofrecidos.
        </p>
        <p>
          Esta sección explica cómo se utilizan los diferentes tipos de cookies
          para asegurar el correcto funcionamiento de los servicios, mejorar la
          experiencia del usuario y analizar los datos.
        </p>
        <span class="cookies__head__title">Cookies Obligatorias</span>
        <p>
          <b>NECESARIAS:</b> Estas cookies son esenciales para que el sitio web
          funcione y también protegen nuestro sitio web de posibles ataques
          cibernéticos y actividades fraudulentas.
        </p>
        <p>
          Con estas también nos aseguramos que se cumpla la ley de protección de
          datos personales. Le informamos de que puede configurar su navegador
          para bloquear o alertar sobre estas cookies, sin embargo, es posible
          que determinadas áreas de la página web no funcionen. Estas cookies no
          almacenan ninguna información de identificación personal.
        </p>
        <span class="cookies__head__title">Cookies Opcionales</span>
        <p>
          <b>ANALÍTICAS:</b> Estas cookies se utilizan para averiguar cómo los
          usuarios están usando nuestro sitio. Esto nos ayuda a corregir áreas
          que pueden no estar funcionando y hacer que el sitio sea más fácil de
          navegar. Además, con la intención de verificar si los cambios que
          hacemos en el sitio web lo hacen mejor o peor para usted.
        </p>
        <p>
          <b>MARKETING:</b> Estas cookies recuerdan los productos que le
          interesan para mostrarle otros productos u ofertas que pueden ser
          relevantes cuando visita otros sitios web.
        </p>
        <p>
          También se utilizan para asegurarnos de que no le mostremos anuncios
          de cosas que ya ha comprado y averiguar si nuestro marketing tuvo
          éxito. Las cookies publicitarias recopilan y guardan información sobre
          qué páginas visita, en qué hace clic y si compra un producto. Si elige
          no aceptar, seguirá viendo anuncios mientras navega por la web, pero
          no serán tan relevantes para sus intereses personales.
        </p>
      </div>
      <div class="hidden-mobile">
        <div class="cookies-buttons d-flex justify-content-center">
          <div class="cookies__btn-config">
            <button type="button" class="btn btn-primary" @click="acceptBasicCookies">
              Solo cookies funcionales
            </button>
          </div>
          <div class="cookies__btn-aceptar">
            <button type="button" class="btn btn-primary" @click="acceptAllCookies">
              Todas las cookies
            </button>
          </div>
        </div>
      </div>

      <div class="visible-mobile">
        <div>
          <div class="cookies__btn-config">
            <button type="button" class="btn btn-primary" @click="acceptBasicCookies">
              Solo cookies funcionales
            </button>
          </div>
        </div>
        <div>
          <div class="cookies__btn-aceptar">
            <button type="button" class="btn btn-primary" @click="acceptAllCookies">
              Todas las cookies
            </button>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal id="comunications-policies-modal" ok-only ok-title="Entendido" centered size="lg"
      modal-class="modal-conditions" title="Política de Comunicaciones" ref="comunications-policies-modal">
      <b-card-text>
        <div class="general-conditions">
          <p>
            Usted puede brindar su consentimiento para que INTERSEGURO, las
            <a href="https://www.interseguro.pe/soat/archivo/Pol%C3%ADtica_de_Privacidad_de_Interseguro-Anexo_1.pdf"
              target="_blank">empresas del Grupo Intercorp y/o sus socios comerciales:</a>
          </p>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="chkbxPolicies1"
              v-model="comunicationPolicies.profile" />
            <label class="custom-control-label" for="chkbxPolicies1">Realicen estudios de mercado y perfiles de compra.
            </label>
          </div>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="chkbxPolicies2"
              v-model="comunicationPolicies.offers" />
            <label class="custom-control-label" for="chkbxPolicies2">Envíen publicidad, promociones y ofertas de los
              productos y/o
              servicios.
            </label>
          </div>
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="chkbxPolicies3" :checked="comunicationPolicies.profile && comunicationPolicies.offers
              " v-model="comunicationPolicies.all" @change="changeComunicationPolicyContiion()" />
            <label class="custom-control-label" for="chkbxPolicies3">Sí a todo.
            </label>
          </div>
        </div>
      </b-card-text>
    </b-modal>
  </div>

  <!-- COOKIES -->
  <!-- <div class="homeView-cookies" v-if="flags.showCookiesConsent">
        <div class="card">
            <div class="card-body">
                <div class="hidden-mobile">
                    <div class="row d-flex align-items-center">
                        <div class="col-7">
                            <div class="homeView-cookies__title">
                                <span>Consentimiento de Cookies</span>
                            </div>
                            <div class="homeView-cookies__text">
                                <p>
                                    En INTERSEGURO utilizamos las cookies con el fin de asegurar
                                    la seguridad de nuestro sitio y ofrecerte una experiencia
                                    personalizada mejorada. Si deseas saber más sobre su uso, por
                                    favor consulta nuestra política de cookies. Puedes aceptar
                                    todas las cookies haciendo clic en el botón “Aceptar”, o bien,
                                    configurar su uso mediante la opción “Configurar”.
                                </p>
                            </div>
                        </div>
                        <div class="buttons col-3 d-flex justify-content-right">
                            <div class="homeView-cookies__btn-config">
                                <button type="button" class="btn btn-primary" @click="openCookiesModal()">
                                    Configurar
                                </button>
                            </div>
                            <div class="homeView-cookies__btn-aceptar">
                                <button type="button" class="btn btn-primary" @click="acceptAllCookies">
                                    Aceptar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="visible-mobile">
                    <div class="row d-flex">
                        <div class="col-12">
                            <div class="homeView-cookies__title">
                                <span>Consentimiento de Cookies</span>
                            </div>
                            <div class="homeView-cookies__text">
                                <p>
                                    En INTERSEGURO utilizamos las cookies con el fin de asegurar
                                    la seguridad de nuestro sitio y ofrecerte una experiencia
                                    personalizada mejorada. Si deseas saber más sobre su uso, por
                                    favor consulta nuestra política de cookies. Puedes aceptar
                                    todas las cookies haciendo clic en el botón “Aceptar”, o bien,
                                    configurar su uso mediante la opción “Configurar”.
                                </p>
                            </div>
                            <div>
                                <div class="homeView-cookies__btn-config">
                                    <button type="button" class="btn btn-primary" @click="openCookiesModal()">
                                        Configurar
                                    </button>
                                </div>
                                <div class="homeView-cookies__btn-aceptar mb-1">
                                    <button type="button" class="btn btn-primary" @click="acceptAllCookies">Aceptar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</template>







<script lang="ts">
import {
  BButton,
  BModal,
  VBModal,
  BCardText,
  BCollapse,
  BCard,
  VBToggle,
} from "bootstrap-vue";
import VueSimpleRangeSlider from "vue-simple-range-slider";
//import "vue-simple-range-slider/dist/vueSimpleRangeSlider.css";
import "vue-simple-range-slider/css";
import {
  required,
  minLength,
  maxLength,
  email,
  numeric,
  sameAs,
  requiredIf,
} from "vuelidate/lib/validators";
import axios from "axios";
import carousel from "vue-owl-carousel2";
import ISHash from "../../@core/is-hash/is-hash";
import trackingService from "../../services/tracking-service";
import userService from "../../services/user-service";
import { environment } from "../../environment/environment";
import { defineComponent } from "vue";
import moment from "moment";
import useValidate from "@vuelidate/core";



export default defineComponent({
  components: {
    VueSimpleRangeSlider,
    BButton,
    BCardText,
    BCollapse,
    BCard,
    BModal,
    carousel,
  },
  directives: {
    "b-toggle": VBToggle,
    "b-modal": VBModal,
  },
  data() {
    return {
      basePath: /*window["basePath"]*/ "",
      v$: useValidate(),
      apiUrl: environment.api,
      pdfPath: require('@/assets/docs/Folleteria.pdf'),
      userInfo: {
        identificationNumber: "",
        identificationType: "dni",
        email: "",
        age: 0,
      },
      login: {
        identificationNumber: "",
        identificationType: "dni",
      },
      lead: {
        email: "",
      },
      otpCode: {
        code: "",
      },
      countdownInterval: null,
      days: 2,
      hours: 23,
      minutes: 59,
      seconds: 59,
      flags: {
        invalidCard: false,
        paymentCompleted: false,
        disabledInputs: true,
        olderThanAllowedAge: false,
        validateOtp: false,
        logingIn: false,
        searching: false,
        savingLead: false,
        savedLead: false,
        showFaq: false,
        invalidAge: false,
        showError: false,
        showCookiesConsent: true,

      },
      policies: false,
      comunicationPolicies: {
        profile: false,
        offers: false,
        all: false,
      },
      otp: null,
      carouselItems: 0,
      carouselItemsLogos: 0,
      errors: {
        login: "",
      },
      documentLength: 8,
      faq: [
        {
          id: 1,
          show: false,
          question: "¿Qué pasa con mi dinero si ya no estoy?",
          answer:
            "En caso de muerte, protegeremos a tu familia con el seguro por fallecimiento. Solo debes llamar al (01) 500-0000.",
        },
        {
          id: 2,
          show: false,
          question: "¿Qué pasa si no puedo aportar un monto fijo cada mes?",
          answer:
            "Recuerda que con Rumbo puedes acceder al congelamiento de tu plan, siempre y cuando tengas como mínimo 12 aportes realizados.",
        },
        {
          id: 3,
          show: false,
          question: "¿Por cuántos meses puedo congelar mi póliza?",
          answer:
            "Como máximo puedes congelar hasta 2 meses de aportes en la vigencia total de tu póliza. Estos meses serán agregados al finalizar tu plan.",
        },
        {
          id: 4,
          show: false,
          question: "¿Qué pasos debo seguir para congelar mi plan?",
          answer:
            "Si ya cuentas con 12 meses de contribución, podrás gestionar el congelamiento de tu plan en tu Zona Cliente o enviando un correo a rumbo@interseguro.com.pe.",
        },
        {
          id: 5,
          show: false,
          question:
            "¿Qué necesito para solicitar el retiro de mis ahorros al término de mi contrato?",
          answer:
            "¡Todo es 100% online y sin papeleos! Desde tu Zona Cliente te solicitaremos tus datos personales y tu número de cuenta para el depósito bancario.",
        },
        {
          id: 6,
          show: false,
          question: "¿Qué pasa si decido no continuar?",
          answer:
            "Tienes 15 días (desde que te enviamos la póliza) para ejercer tu derecho de arrepentimiento y te devolveremos el total de la prima pagada.",
        },
      ],
    };
  },
  validations: function () {
    return {
      userInfo: {
        identificationType: { required },
        identificationNumber: {
          required,
          numeric,
          // minLength: minLength(this.documentLength),
          // maxLength: maxLength(this.documentLength),
        },
        email: {},
        age: {},
      },
      lead: {
        email: { required, email },
      },
      login: {
        identificationType: { required },
        identificationNumber: { required },
      },
      otpCode: {
        code: { required, numeric },
      },
    };
  },
  created() {
    this.init();
    this.validateCookies();
    window.addEventListener("scroll", this.onWindowScroll);
    if (window.innerWidth >= 480) {
      this.faq.forEach((element) => {
        element.show = true;
      });
    }
  },
  methods: {
    init() {
      this.loadCarousel();
      this.initCountdown();
      this.checkDocumentNumber();
      this.initBraze();
    },
    initBraze() {
      window["braze"].openSession();
    },
    loadCarousel() {
      let width = window.innerWidth;

      if (width < 720) {
        this.carouselItems = 1;
      } else {
        this.carouselItems = 3;
      }
      // this.carouselItems = 1;

      if (width < 720) {
        this.carouselItemsLogos = 2;
      } else {
        this.carouselItemLogos = 6;
      }
    },

    changeComunicationPolicyContiion() {
      // if(this.comunicationPolicies.profile && this.comunicationPolicies.offers) {
      //   this.comunicationPolicies.all = true;
      // } else {
      //   this.comunicationPolicies.all = false;
      // }

      if (this.comunicationPolicies.all) {
        this.comunicationPolicies.profile = true;
        this.comunicationPolicies.offers = true;
      } else {
        this.comunicationPolicies.profile = false;
        this.comunicationPolicies.offers = false;
      }
    },

    goToTyc() {
      this.$router.push({
        name: "tyc"
      });
    },

    async checkDocumentNumber() {
      let queryParams = this.$route.query;
      // let validator: any = this.v$;

      if (!queryParams) return;

      if (queryParams && queryParams.document) {
        this.userInfo.identificationNumber = queryParams.document;

        // if (validator.userInfo.$invalid) {
        //   validator.userInfo.$touch();
        //   return;
        // }

        this.flags.searching = true;

        var user = await this.getUser();

        if (user) {
          let leadResponse = await userService.getUserLead(
            this.userInfo.identificationNumber
          );

          if (leadResponse.data) {
            if (leadResponse.data.screen !== "home") {
              window.localStorage.setItem(
                "__quoteLeadDetail__",
                JSON.stringify(leadResponse.data.data)
              );
            }

            let queryParams = this.$route.query;
            this.$router.push({
              name: "quote",
              query: queryParams,
            });
          }
        }
      }
    },
    initCountdown() {
      let _context = this;
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }

      let fechalimite: any = moment("2023-06-18 11:59:00");
      let fechaactual: any = moment();

      let fecha = moment(fechalimite - fechaactual);

      _context.days = fecha.format("D");
      _context.hours = fecha.format("H");
      _context.minutes = fecha.format("m");
      _context.seconds = fecha.format("s");

      this.countdownInterval = setInterval(() => {
        _context.seconds--;

        if (_context.seconds === 0) {
          _context.seconds = 59;
          _context.minutes--;
        }

        if (_context.minutes === 0) {
          _context.minutes = 59;
          _context.hours--;
        }
      }, 1000);
    },
    closeModalNoInsurance() {
      this.$refs["modal-no-insurance"].hide();
    },
    startQuote(event: any) {
      event.preventDefault();

      let validator: any = this.v$;

      if (validator.userInfo.$invalid) {
        validator.userInfo.$touch();
        return;
      }

      window.location.href = `/quote?documentType=${this.userInfo.identificationType}&documentNumber=${this.userInfo.identificationNumber}`;
    },
    async loadUser(event: any) {
      let validator: any = this.v$;

      this.userInfo.identificationNumber =
        this.userInfo.identificationNumber.toString();

      if (event) event.preventDefault();

      if (validator.userInfo.$invalid) {
        validator.userInfo.$touch();
        return;
      }

      if (this.flags.invalidAge) {
        return;
      }

      this.flags.searching = true;

      this.sendQuoteEvent();

      this.saveDataLayerEvent({
        event: "select_button",
        "Nombre Sección": "Rumbo",
        TipoElemento: "Botón",
        TipoAccion: "Paso 1 - Ingrese DNI/CE",
        CTA:
          "Seleccionar botón - Cotizar - " + this.userInfo.identificationType,
      });

      this.saveDataLayerEvent({
        event: "virtualEvent",
        category: "Rumbo",
        action: "Paso 1 - Ingrese DNI/CE",
        label:
          "Seleccionar botón - Cotizar - " + this.userInfo.identificationType,
      });

      var user = await this.getUser();

      if (!user) {
        return;
      }

      this.flags.searching = false;

      let queryParams = this.$route.query;
      this.$router.push({
        name: "quote",
        query: queryParams,
      });
    },
    async getUser() {
      var user = null;
      var result = await userService.getUserInfo(
        this.userInfo.identificationNumber
      );

      if (result.data) {
        const data = result.data;

        if (data.data.montoParaAdquirirPoliza < 25000) {
          let refs: any = this.$refs;
          refs["modal-no-insurance"].show();
          this.flags.searching = false;
          return;
        }

        let dateOfBirth = "";
        if (
          data.data &&
          data.data.fechaNacimiento &&
          data.data.fechaNacimiento !== ""
        ) {
          let dateParts = data.data.fechaNacimiento.split("/");
          dateOfBirth = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
        }

        user = {
          firstName: data.data.nombre,
          lastName: data.data.apellidoPaterno,
          secondLastName: data.data.apellidoMaterno,
          email: data.data.email,
          dateOfBirth: dateOfBirth,
          phone: data.data.numeroTelefono,
          gender: data.data.sexo,
          identificationNumber: this.userInfo.identificationNumber,
          identificationType: this.userInfo.identificationType,
        };

        window.localStorage.setItem(
          "__quoteDocumentType__",
          this.userInfo.identificationType
        );
        window.localStorage.setItem(
          "__quoteDocumentNumber__",
          this.userInfo.identificationNumber
        );
        window.localStorage.setItem("__quoteUser__", JSON.stringify(user));
        window.localStorage.setItem("__quoteEmail__", this.userInfo.email);
      }

      return user;
    },
    sendQuoteEvent() {
      let documentCode = "01";

      if (this.userInfo.identificationType === "ce") documentCode = "02";

      let hashText =
        documentCode + this.userInfo.identificationNumber.padStart(15, "0");

      let hashId = ISHash.hash(hashText).toUpperCase();
      this.$braze.openSession();
      this.$braze.changeUser(hashId);

      window.localStorage.setItem("__hashiId__", hashId);

      this.saveDataLayerEvent({
        userProperties: {
          userID: hashId,
          origen: "Front",
          tipoDoc: this.userInfo.identificationType,
          numeroDoc: this.userInfo.identificationNumber,
          loginStatus: "Sesión Iniciada",
        }
      })

      /*this.saveDataLayerEvent({
        userID: hashId,
        loginStatus: "Sesión Iniciada",
        empresa: "Interseguro",
      });*/

      // window["braze"].changeUser(hashId);
    },
    async sendOtp(e) {
      e.preventDefault();

      let validate: any = this.v$;

      if (validate.login.$invalid) {
        validate.login.$touch();
        return;
      }

      this.saveDataLayerEvent({
        event: "select_button",
        "Nombre Sección": "Rumbo",
        TipoElemento: "Botón",
        TipoAccion: "Login - Seleccionar Continuar",
        CTA: this.login.identificationType,
      });

      this.flags.logingIn = true;
      this.errors.login = "";

      let model = {
        identificationType: this.login.identificationType,
        identificationNumber: this.login.identificationNumber.toString(),
      };

      try {
        var result = await axios.post(
          `${this.apiUrl}sign-in/otp/generate`,
          model
        );

        if (result.data) {
          this.flags.validateOtp = true;
          this.flags.logingIn = false;

          this.otp = result.data;
        }
      } catch (error: any) {
        this.flags.logingIn = false;
        this.errors.login = error.response.data.detail;
      }
    },
    async validateOtp(e: any) {
      e.preventDefault();

      let validator: any = this.v$;

      if (validator.otpCode.$invalid) {
        validator.otpCode.$touch();
        return;
      }

      this.flags.logingIn = true;

      this.login.identificationNumber = this.login.identificationNumber;

      let model = {
        identificationType: this.login.identificationType,
        identificationNumber: this.login.identificationNumber,
        code: this.otpCode.code,
        otpId: this.otp.otpId,
      };

      try {
        var result = await axios.post(
          `${this.apiUrl}sign-in/otp/validate`,
          model
        );

        if (result.data) {
          window.localStorage.setItem("__auth__", JSON.stringify(result.data));

          let headers = {
            headers: {
              Authorization:
                result.data.token_type + " " + result.data.access_token,
            },
          };

          var userResult = await axios.get(`${this.apiUrl}users/me`, headers);

          if (userResult.data) {
            window.localStorage.setItem(
              "__user__",
              JSON.stringify(userResult.data)
            );
          }

          this.sendLoginEvent();

          if (
            this.login.identificationNumber.toUpperCase().indexOf("XX") > -1
          ) {
            window.location.href = `/seguro-de-vida/rumbo/admin/policies`;
          } else {
            window.location.href = `/seguro-de-vida/rumbo/client-zone/policies`;
          }
        } else {
          this.flags.logingIn = false;
        }
      } catch (error) {
        console.log(error);
        this.flags.logingIn = false;
        this.errors.login = error.response.data.detail;
      }
    },
    sendLoginEvent() {
      let documentCode = "01";

      if (this.login.identificationType === "ce") documentCode = "02";

      let hashText =
        documentCode + this.login.identificationNumber.padStart(15, "0");

      let hashId = ISHash.hash(hashText).toUpperCase();

      this.saveDataLayerEvent({
        userID: hashId,
        loginStatus: "Sesión Iniciada",
        empresa: "Interseguro",
      });

      // window["braze"].changeUser(hashId);
    },
    async saveLead(event: any) {
      event.preventDefault();

      let _context = this;

      let validator: any = this.v$;

      if (validator.lead.$invalid) {
        validator.lead.$touch();
        return;
      }

      this.saveDataLayerEvent({
        event: "select_button",
        "Nombre Sección": "Rumbo",
        TipoElemento: "Botón",
        TipoAccion: "Lead - Quiero más información",
        CTA: this.lead.email,
      });

      this.flags.savingLead = true;

      let model = {
        leadId: this.newGuid(),
        planName: "",
        step: "",
        customer: {
          identificationType: "",
          identificationNumber: "",
          firstName: "",
          lastName: "",
          secondLastName: "",
          dateOfBirth: "",
          gender: true,
          email: this.lead.email,
          phone: "",
          auhorizePersonalData: true,
        },
      };

      try {
        var result = await axios.post(`${this.apiUrl}leads`, model);

        this.flags.savingLead = false;
        this.flags.savedLead = true;
        this.lead.email = "";

        setTimeout(() => {
          _context.flags.savedLead = false;
        }, 3000);
      } catch (error) {
        this.flags.savingLead = false;
      }
    },
    newGuid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          var r = (Math.random() * 16) | 0,
            v = c == "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
    },
    saveDataLayerEvent(event: any) {
      if (window["dataLayer"]) {
        window["dataLayer"].push(event);
      }
    },
    saveLoginEvent() {
      this.saveDataLayerEvent({
        event: "virtualPageView",
        pageTitle: "Rumbo | Login",
        pageUrl: "login/inicio",
      });
    },
    onWindowScroll(event: any) {
      let width = window.innerWidth;

      // if (width > 639) {
      let scrollTop = window.scrollY;
      var element: any = document.getElementById("goals");
      var chatButton: any = document.getElementById("chatButton");

      // if (scrollTop > 500) {
      //     element.classList.add("fixed");
      //     chatButton.classList.remove("d-none");
      // } else {
      //     element.classList.remove("fixed");
      //     chatButton.classList.add("d-none");
      // }
      // }
    },
    validateAge() {
      if (this.userInfo.age < 18 || this.userInfo.age > 60) {
        this.flags.invalidAge = true;
      } else {
        this.flags.invalidAge = false;
      }
    },
    redirectToQuote() {
      let _context = this;
      if (this.userInfo.identificationNumber.length === this.documentLength) {
        _context.loadUser(null);
      }
    },
    setDocumentLength() {
      var length = 8;
      if (this.userInfo.identificationType !== "dni") {
        length = 9;
      }

      this.documentLength = length;
    },
    validateInput(event: any) {
      // if (isNaN(event.key)) {
      //   event.preventDefault();
      // }
    },
    openCookiesModal() {
      this.$refs["modal-cookies"].show();
    },
    setCookie(cname, cvalue) {
      var now = new Date();
      var time = now.getTime();
      var expireTime = time + 1000 * 36000;
      now.setTime(expireTime);
      document.cookie =
        cname + "=" + cvalue + ";expires=" + now.toUTCString() + ";path=/";
    },
    acceptAllCookies() {
      this.setCookie("ad_storage", "granted");
      this.setCookie("analytics_storage", "granted");
      this.setCookie("functionality_storage", "granted");
      this.setCookie("personalization_storage", "granted");
      this.setCookie("security_storage", "granted");

      this.saveDataLayerEvent({ event: "consent_update" });

      localStorage.setItem("__cookiesConsent__", "true");
      this.flags.showCookiesConsent = false;

      this.saveDataLayerEvent({
        event: "virtualPageGA4",
        pagePath: "/",
        pageTitle: "Rumbo Home",
      });

      this.$refs["modal-cookies"].hide();
    },
    acceptBasicCookies() {
      this.setCookie("functionality_storage", "granted");
      this.setCookie("personalization_storage", "granted");
      this.setCookie("security_storage", "granted");

      this.saveDataLayerEvent({ event: "consent_update" });

      localStorage.setItem("__cookiesConsent__", "true");
      this.flags.showCookiesConsent = false;

      this.$refs["modal-cookies"].hide();
    },
    validateCookies() {
      let acceptedCookies = localStorage.getItem("__cookiesConsent__");

      this.flags.showCookiesConsent = !acceptedCookies;
    },
    openWapp() {
      this.saveDataLayerEvent({
        event: "virtualEvent",
        category: "Rumbo",
        action: "Canales de comunicación",
        label: "WhatsApp - Comunicarse con un asesor",
      });

      this.saveDataLayerEvent({
        event: "select_button",
        "Nombre Sección": "Rumbo",
        TipoElemento: "Botón",
        TipoAccion: "Canales de comunicación",
        CTA: "WhatsApp - Comunicarse con un asesor",
      });
    },
  },
  mounted() {
    localStorage.clear()
  }
});
</script>

<style lang="scss">
/**/
@import "./../../styles/abstracts/variables";
/**/

/*
  MODAL
  */

.modal-backdrop {
  background-color: rgba($color: #22292f, $alpha: 0.5) !important;
}

/*
  MOB
  */

.hidden-mobile {
  @media (max-width: $mobileBreak) {
    display: none;
  }
}

.visible-mobile {
  @media (min-width: $desktopBreak) {
    display: none;
  }
}

/*
  HOME
  */

.home {
  &__head {
    .container {
      @media (min-width: $desktopBreak) {
        padding: 0 !important;
      }
    }

    .navbar-brand {
      display: flex;
      width: 292px;
      align-items: center;
      justify-content: space-between;

      @media (max-width: $mobileBreak) {
        padding: 12px 0px 12px 0px;
        width: 255px;
      }

      img:nth-child(1) {
        width: 150px;
        height: 24px;

        @media (max-width: $mobileBreak) {
          width: 140px;
          height: 20px;
        }
      }

      img:nth-child(2) {
        width: 130px;

        @media (max-width: $mobileBreak) {
          width: 100px;
        }
      }
    }

    .navbar {
      position: relative;

      .navbar-nav {
        padding: 0;
        height: 54px;

        @media (max-width: $mobileBreak) {
          position: absolute;
          left: 0;
          width: 100%;
          background-color: rgba($color: #ffffff, $alpha: 0.9);
        }
      }
    }

    .navbar-toggler {
      background-color: transparent;
      border-color: transparent;

      &:focus {
        box-shadow: none;
      }

      .fa-bars {
        color: #003aad;
        font-size: 30px;
      }
    }

    // .navbar-toggler-icon {
    //   color: red;
    // }

    .navbar-nav {
      padding-top: 15px;
      align-items: center;

      .nav-item {
        .nav-link {
          font-family: $firstFont;
          font-weight: 500;
          font-size: 14px;
          display: block;
          text-decoration: none;
          color: #0855c4;
          margin-right: 35px;

          @media (max-width: $mobileBreak) {
            margin: 0;
            padding: 5px 0px 5px 0px;
          }
        }

        .nav-link-questions {
          font-family: $firstFont;
          font-weight: 600;
          font-size: 14px;
          display: block;
          text-decoration: none;
          color: #0855c4 !important;
          margin-right: 35px;

          @media (max-width: $mobileBreak) {
            margin: 0;
            padding: 5px 0px 5px 0px;
          }
        }

        .nav-btn {
          font-weight: 500;
          margin-right: 0;
          color: white;
          padding: 5px 9px 5px 9px;
          border-radius: 8px;
          background-color: $primaryBlue;

          @media (max-width: $mobileBreak) {
            margin: 10px 0px 10px 0px;
          }
        }
      }
    }
  }

  .home__quote-card,
  .quote-card {
    width: 100%;
    padding: 35px;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
    background-color: white;

    @media (max-width: $mobileBreak) {
      margin-top: -5px !important;
      margin-bottom: 30px;
      box-shadow: 0px 2px 8px rgba($color: #000000, $alpha: 0.2);
      padding-left: 17px !important;
      padding-right: 2px !important;
    }

    form {
      .policies {
        font-size: 12.5px;
        word-spacing: 0.5px;
        color: $primaryGray;
        text-align: center;
        margin-bottom: 5px;

        input {
          width: 12.5px !important;
          height: 12.5px !important;
          margin: 5px;
        }

        .custom-control {
          display: flex;
          justify-content: center;

          input {
            position: absolute;
          }

          &-label {
            position: relative;
            display: flex;
            justify-content: center;
            padding-left: 25px;

            &:before {
              border-radius: 50%;
              border-color: #01adee;
              border-width: 2px;
              left: 0 !important;
              top: 0 !important;
            }

            &:after {
              left: 0 !important;
              top: 0 !important;
            }
          }
        }

        a {
          color: #0855c4;
          font-weight: 400;
          text-decoration: none;
        }
      }

      .form-group {
        font-family: $firstFont;
        font-weight: 400;
        font-size: 14px;
        position: relative;
        display: flex;
        align-items: center;
        margin: 0px 15px 12px 0px;

        .error {
          display: none;
        }

        &.invalid {
          display: block;

          .error {
            font-weight: 600;
            font-size: 13px;
            display: block;
            text-align: left;
            margin: 2px 0px 0px 10px;
            color: $primaryRed;
            width: 100%;
          }
        }

        input[type="radio"] {
          opacity: 0;
          margin-right: 14px;
        }

        input[type="radio"]::after {
          content: "";
          position: absolute;
          z-index: 5;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          cursor: pointer;
          background-color: red;
        }

        input[type="radio"]:checked~label::before {
          background-color: $primaryPurple;
        }

        input[type="radio"]:checked~label::after {
          border: 1px solid $primaryPurple;
        }

        label::before {
          content: "";
          position: absolute;
          z-index: 1;
          top: 0;
          left: 0;
          width: 19px;
          height: 19px;
          border-radius: 50%;
          background-color: transparent;
          cursor: pointer;
          transition: 0.3s;
        }

        label::after {
          content: "";
          position: absolute;
          z-index: 1;
          top: 0;
          left: 0;
          width: 19px;
          height: 19px;
          border-radius: 50%;
          border: 1px solid #d8d6de;
          cursor: pointer;
          transition: 0.3s;
        }

        .form-control {
          font-family: $firstFont;
          font-weight: 400;
          width: 100%;
          padding: 10px;
          text-align: center;
          outline: none;
          border-radius: 5px !important;
          border: 1px solid #d8d6de;
          transition: 0.3s;
        }

        .form-control::placeholder {
          color: #c2c2c2;
        }

        .form-control:focus {
          border: 1px solid $primaryPurple;
          padding-left: 20px;
          box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.1);
        }

        //

        .form-btn {
          font-family: $firstFont;
          font-weight: 500;
          font-size: 17px;
          width: 100%;
          border-radius: 5px;
          padding: 13px;
          border: none;
          color: white;
          background-color: $primaryPink;
        }

        //

        h6 {
          font-weight: 500;
          font-size: 18px;
          width: 100%;
          display: block;
          text-align: center;
          color: $primaryBlue;
          margin: 0;
        }

        p {
          font-size: 14px;
          margin: 0;
          padding-right: 10px;
        }

        img {
          width: 100px;
        }

        span {
          display: block;
          text-align: center;
          width: 100%;

          a {
            font-weight: 500;
            color: $primaryBlue;
          }
        }

        .input-place::placeholder {
          font-size: 16px;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          color: #454a6c !important;
        }
      }
    }

    &.card-slider {
      position: relative;
      // background-color: red !important;
      margin-left: 285px;
      width: 400px !important;
      padding-left: 36px;
      padding-right: 21px;
      padding-top: 20px;

      @media (max-width: 1366px) {
        margin-left: 100px;
        padding: 18px;
        padding-left: 24px;
        padding-right: 9px;
      }
    }

    @media (max-width: $mobileBreak) {
      .cuadro {
        border-radius: 12px 0px;
        background: #0855c4;
        width: 120px;
        height: 35px;
        position: absolute;
        top: -18px;
        right: 20px;

        .desde {
          color: #fff;
          font-size: 18px;
          font-weight: 300 !important;
          padding-right: 7px;
        }

        .quantity {
          color: #fff;
          font-size: 18px;
          font-style: normal;
          font-weight: 600;
          line-height: 120%;
        }
      }
    }
  }

  &__banner {
    display: flex;
    align-items: center;
    width: 100%;
    height: 420px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    background-image: url("@/assets/images/app/portada.png");

    @media (max-width: $mobileBreak) {
      background-position: right;
      max-height: 200px;
    }

    &__text {
      height: 100%;
      padding: 40px;

      @media (max-width: $mobileBreak) {
        padding: 20px;
      }

      h2 {
        font-family: $firstFont;
        font-weight: 600;
        font-size: 40px;
        color: $primaryBlue;

        @media (max-width: $mobileBreak) {
          font-size: 22px;
          padding: 10px;
          width: fit-content;
          border-radius: 10px;
          background-color: rgba(255, 255, 255, 0.6);
        }

        span {
          font-weight: bold;
        }
      }
    }

    &__carousel {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;

      @media (max-width: 1366px) {
        width: 100%;
      }

      @media (max-width: $mobileBreak) {
        position: initial !important;
      }

      &__slider1,
      &__slider2,
      &__slider3 {
        width: 100%;
        background-image: url("@/assets/images/app/MAESTRIA.png");
        background-repeat: no-repeat;
        background-size: cover;
        background-position: right -20px center;
        height: 550px;

        @media (max-width: 1366px) {
          height: 450px !important;
          background-size: cover;
          background-position: right -20px center;
          // width: 1400px;
        }

        @media (max-width: $mobileBreak) {
          background-image: url("@/assets/images/app/maestria-Mobile.png") !important;
        }

        &__text {
          padding-left: 285px;
          margin-bottom: -20px;
          padding-top: 25px;

          @media (max-width: 1366px) {
            padding-left: 100px;
            padding-top: 20px !important;
            margin-bottom: -28px;
          }

          .ahorro {
            color: #454a6c;
            font-size: 30px;
            font-style: normal;
            font-weight: 500;
            line-height: 120%;
          }

          .maestria {
            color: #0855c4;
            font-size: 36px;
            font-style: normal;
            font-weight: 600;
            line-height: 120%;
          }

          .hasta {
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 140%;
          }

          .number {
            color: #ea0d90;
            font-size: 60px;
            font-style: normal;
            font-weight: 600;
            line-height: 120%;
          }

          .porcent {
            color: #ea0d90;
            font-size: 36px;
            font-style: normal;
            font-weight: 600;
            line-height: 120%;
          }

          .trea {
            color: #454a6c;
            font-size: 36px;
            font-style: normal;
            font-weight: 500;
            line-height: 120%;
            padding-left: 12px;
          }
        }

        &__promo {
          .desde {
            color: #fff;
            font-size: 25px;
            font-style: normal;
            font-weight: 300;
            line-height: 120%;
            padding-right: 7px;
          }

          .quantity {
            color: #fff;
            font-size: 25px;
            font-style: normal;
            font-weight: 600;
            line-height: 120%;
          }

          .cuadro {
            border-radius: 12px 0px;
            background: #0855c4;
            width: 156px;
            height: 46px;
            position: absolute;
            top: -24px;
            right: 20px;
          }
        }
      }

      &__slider2 {
        background-image: url("@/assets/images/app/NEGOCIO.png") !important;

        @media (max-width: $mobileBreak) {
          background-image: url("@/assets/images/app/maestria-Mobile.png") !important;
        }
      }

      &__slider3 {
        background-image: url("@/assets/images/app/DEPA.png") !important;

        @media (max-width: $mobileBreak) {
          background-image: url("@/assets/images/app/depa-Mobile.png") !important;
        }
      }

      .owl-theme {
        .owl-nav {
          margin-top: -92px;
          text-align: center;
          -webkit-tap-highlight-color: transparent;
          z-index: 20;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 200px;

          @media (max-width: 1366px) {
            gap: 120px;

            // display: none !important;
          }

          @media (max-width: $mobileBreak) {
            display: none !important;
          }

          .owl-next,
          .owl-prev {
            background-color: #fff !important;
            border-radius: 100%;
            position: relative;
            width: 55px;
            height: 55px;
          }

          .owl-next::before {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(45deg);
            border: solid #454a6c;
            border-width: 4px 4px 0 0;
            width: 20px;
            height: 20px;
            position: absolute;
            left: 25px;
          }

          .owl-prev::before {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(-45deg);
            border: solid #454a6c;
            border-width: 4px 0 0 4px;
            width: 20px;
            height: 20px;
            position: absolute;
            left: 30px;
          }
        }
      }
    }

    &__newBanner,
    &__newBanner2,
    &__newBanner3 {
      background-image: url("@/assets/images/app/depa-Mobile.png");
      background-size: cover;
      width: 101%;
      background-position: center;
      height: 260px;

      &__text {
        padding-left: 20px;
        position: relative;

        .ahorro {
          color: #454a6c;
          font-size: 30px;
          font-style: normal;
          font-weight: 500;
          line-height: 120%;
        }

        .maestria {
          color: #0855c4;
          font-size: 36px;
          font-style: normal;
          font-weight: 600;
          line-height: 120%;
        }

        .hasta1 {
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          padding-left: 20px;
          position: absolute;
          top: 140px;
        }

        .hasta2 {
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          padding-left: 20px;
          position: absolute;
          top: 143px;
        }

        .hasta {
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          padding-left: 20px;
          position: absolute;
          top: 143px;
        }

        &__content-trea {
          padding-left: 20px;
          padding-top: 43px;

          .number {
            color: #ea0d90;
            font-size: 36px;
            font-style: normal;
            font-weight: 600;
            line-height: 120%;
          }

          .trea {
            color: #454a6c;
            font-size: 20px;
            font-style: normal;
            font-weight: 500;
            line-height: 120%;
            padding-left: 4px;
          }
        }

        &__content-trea-depa {
          padding-left: 20px;
          padding-top: 85px;

          .number {
            color: #ea0d90;
            font-size: 36px;
            font-style: normal;
            font-weight: 600;
            line-height: 120%;
          }

          .trea {
            color: #454a6c;
            font-size: 20px;
            font-style: normal;
            font-weight: 500;
            line-height: 120%;
            padding-left: 4px;
          }
        }

        &__content-trea-maestria {
          padding-left: 20px;
          padding-top: 85px;

          .number {
            color: #ea0d90;
            font-size: 36px;
            font-style: normal;
            font-weight: 600;
            line-height: 120%;
          }

          .trea {
            color: #454a6c;
            font-size: 20px;
            font-style: normal;
            font-weight: 500;
            line-height: 120%;
            padding-left: 4px;
          }
        }
      }
    }

    &__newBanner2 {
      @media (max-width: $mobileBreak) {
        background-image: url("@/assets/images/app/negocio-Mobile.png");
      }
    }

    &__newBanner3 {
      @media (max-width: $mobileBreak) {
        background-image: url("@/assets/images/app/maestria-Mobile.png");
      }
    }
  }

  &__banner-message {
    width: 100%;
    padding: 40px;
    color: white;
    text-align: center;
    background-color: $primaryBlue;
    position: relative;
    z-index: 1000;

    @media (max-width: $mobileBreak) {
      border-radius: 8px;
      padding: 20px;
      margin-bottom: 40px;

      h2 {
        font-size: 19px;
        font-weight: 500;
      }
    }
  }

  &__section-benefits {
    position: relative;
    background-color: rgba(241, 244, 249, 0.5019607843137255);

    .container {
      position: relative;
      z-index: 10;
    }

    &::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 592px;
      height: 500px;
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center;
      background-image: url("@/assets/images/app/free.png");

      @media (max-width: $mobileBreak) {
        display: none;
      }
    }

    @media (max-width: $mobileBreak) {
      .row {
        padding: 0px 25px 0px 25px;
      }
    }

    h2 {
      color: $primaryBlue;
      text-align: center;
      padding: 50px 0px 90px 0px;

      @media (max-width: $mobileBreak) {
        font-size: 23px;
        padding: 25px 0px 40px 0px;
      }
    }

    &__title {
      display: flex;
      align-items: center;
      margin-left: 40px;
      justify-content: start;

      @media (max-width: $mobileBreak) {
        margin: 0;
        justify-content: center;
      }

      img {
        margin-right: 14px;
      }

      span {
        font-size: 20px;
        font-weight: 500;
        color: $primaryGray;

        @media (max-width: $mobileBreak) {
          font-size: 21px;
        }
      }
    }

    &__separator {
      display: block;
      width: 100%;
      height: 2px;
      margin: 25px 0px 40px 0px;
      opacity: 0.4;
      background-color: $primaryGray;
    }

    .col-sm {
      margin: 0px 0px 40px 0px;

      @media (max-width: $mobileBreak) {
        margin: 0px 0px 30px 0px;
      }
    }

    &__benefit {
      display: flex;

      .benefit-img {
        margin-right: 10px;
      }

      span {
        display: block;
        font-size: 19px;

        @media (max-width: $mobileBreak) {
          font-size: 20px;
        }
      }
    }

    &__btn {
      font-family: $firstFont;
      font-weight: 500;
      font-size: 20px;
      border-radius: 5px;
      padding: 15px 120px 15px 120px;
      border: none;
      color: white;
      background-color: $primaryPink;
      text-decoration: none;

      @media (max-width: $mobileBreak) {
        padding: 15px;
        width: 100%;
        display: flex;
        justify-content: center;
      }
    }

    &__btn:link,
    &__btn:visited,
    &__btn:hover,
    &__btn:active {
      color: white;
    }

    &__note {
      display: block;
      text-align: center;
      font-size: 18px;
      margin: 40px 0px 20px 0px;
    }
  }

  &__section-savings {
    h2 {
      font-size: 30px;
      color: $primaryBlue;
      text-align: center;
      padding: 50px 0px 90px 0px;

      @media (max-width: $mobileBreak) {
        padding: 50px 0px 60px 0px;
        font-size: 22px;
      }
    }

    &__image {
      padding: 0px 0px 50px 0px;

      img:first-child {
        width: 100%;

        @media (max-width: $mobileBreak) {
          display: none;
        }
      }

      img:last-child {
        width: 100%;
        margin-bottom: -2rem;
        @media (min-width: $tabletBreak) {
          display: none;
        }
      }
    }

    .somosParteDe {
      display: flex;
      justify-content: center;

      &__logo {
        img {
          width: 240px;
        }
      }
    }

    .Logos {
      display: flex;
      margin: 4px, 4px;
      padding: 4px;
      // width: 500px;
      overflow: auto;
      white-space: nowrap;
      overflow-x: scroll;
      align-items: center;

      &__content {
        img {
          margin: 20px;
        }

        .interbank {
          img {
            width: 150px;
          }
        }

        .interseguro {
          img {
            width: 160px;
          }
        }

        .plazavea {
          img {
            width: 118px;
          }
        }

        .financieraoh {
          img {
            width: 170px;
          }
        }
      }
    }
  }

  &__section-quote {
    padding: 0px 0px 20px 0px;
    background: rgba(241, 244, 249, 0.5019607843137255) 0 0 no-repeat padding-box;

    h2 {
      font-size: 30px;
      color: $primaryBlue;
      text-align: center;
      padding: 50px 0px 40px 0px;

      @media (max-width: $mobileBreak) {
        padding: 30px 0px 20px 0px !important;
        font-size: 22px;
      }
    }

    .col-sm,
    .col-sm-5 {
      @media (max-width: $mobileBreak) {
        margin-bottom: 40px;
      }
    }

    &__steps {
      list-style: none;
      margin: 0;
      padding: 0;
      margin-top: 90px;

      @media (max-width: $mobileBreak) {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        //margin-left: 21px;
        margin-top: 20px;
      }

      li {
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        @media (max-width: $mobileBreak) {
          width: 100%;
          padding: 10px;
          width: 48%;
          margin-left: 8px;
          border-radius: 10px;
          background-color: #e2f7ff;

          &:nth-child(1) {
            margin-left: 0px;
          }

          &:nth-child(3) {
            margin-left: 0px;
          }
        }
      }

      &__img {
        margin-right: 15px;

        @media (max-width: $mobileBreak) {
          display: none;
        }
      }

      &__text {
        span {
          font-weight: 500;
          color: $primaryBlue;
        }

        p {
          font-weight: 500;
          color: $primaryGray;
          margin: 0;
        }
      }
    }

    &__gif {
      img {
        width: 250px;
        margin-left: 30px;

        @media (max-width: $mobileBreak) {
          margin: 0;
        }
      }
    }

    &__note {
      font-weight: 500;
      font-size: 18px;
      color: $primaryBlue;
      display: block;
      width: 100%;
      text-align: center;

      @media (max-width: $mobileBreak) {
        display: none;
      }
    }
  }

  &__section-feedback {
    padding: 0px 0px 18px 0px;

    .container {
      @media (min-width: $desktopBreak) {
        padding: 0 !important;
        // margin-bottom: -445px !important;
      }
    }

    h2 {
      font-size: 30px;
      color: $primaryBlue;
      text-align: center;
      padding: 50px 0px 50px 0px;

      @media (max-width: $mobileBreak) {
        padding: 30px 0px 30px 0px;
        font-size: 22px;
      }
    }

    .owl-item {
      @media (min-width: $tabletBreak) {
        width: 460px !important;
        margin-right: -20px;
        padding: 8px 30px 8px 20px;
      }
    }

    &__card {
      position: relative;
      padding: 50px;
      margin: 20px 0;
      width: 100%;
      border-radius: 5px;
      border: 1px solid $secondGray;
      box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.1);

      &::before {
        content: "";
        position: absolute;
        top: -20px;
        left: 50%;
        z-index: 5;
        width: 45px;
        height: 50px;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url("@/assets/images/app/shield.png");
        transform: translateX(-50%);
      }

      &::after {
        content: "";
        position: absolute;
        top: -20px;
        left: 50%;
        z-index: 1;
        width: 70px;
        height: 20px;
        background-color: white;
        transform: translateX(-50%);
      }

      &__head {
        display: flex;
        justify-content: center;

        img {
          width: 100px !important;
        }
      }

      &__body {
        font-size: 19px;
        font-style: italic;
        height: 140px;
        overflow: hidden;
        color: $primaryGray;
        margin-top: 25px;
      }

      &__footer {
        display: flex;
        justify-content: center;
        width: 100%;
        height: 40px;

        p {
          font-weight: 600;
          font-size: 18px;
          text-align: center;
          color: $primaryGray;
          position: absolute;
          bottom: 0;
        }
      }
    }
  }

  &__section-faq {
    padding: 0px 0px 70px 0px;
    background: rgba(241, 244, 249, 0.5019607843137255) 0 0 no-repeat padding-box;

    h2 {
      font-size: 30px;
      color: $primaryBlue;
      text-align: center;
      padding: 50px 0px 50px 0px;

      @media (max-width: $mobileBreak) {
        padding: 30px 0px 30px 0px;
        font-size: 22px;
      }
    }

    &__list {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: center;
    }

    &__card {
      width: 350px;
      text-align: center;
      margin: 0px 15px 60px 45px;

      @media (max-width: $mobileBreak) {
        width: 100%;
        margin: 0px 40px 20px 40px;
      }

      span {
        position: relative;
        width: 100%;
        height: 90px;
        display: flex;
        padding: 12px;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        border: 1px solid $primaryGray;

        @media (max-width: $mobileBreak) {
          text-align: left;
          padding-right: 50px;
          font-size: 14px;
          justify-content: space-between;
          border: none;
          height: 60px;
          border-bottom: 1px solid $primaryGray;

          &::after {
            content: "";
            position: absolute;
            right: 10px;
            bottom: 20px;
            width: 15px;
            height: 15px;
            border: 3px solid $primaryBlue;
            border-right: none;
            border-top: none;
            transform: rotate(-45deg);
          }
        }
      }

      &.open {
        span {
          @media (max-width: $mobileBreak) {
            &::after {
              transform: rotate(135deg);
            }
          }
        }
      }

      p {
        margin: 0;
        padding: 15px;
        color: $primaryGray;

        @media (max-width: $mobileBreak) {
          font-size: 14px;
          text-align: justify;
        }
      }
    }
  }

  .imagen-button {
    position: fixed;
    bottom: 1rem !important;
    right: 20px;
    z-index: 1000;

    &.folleto {
      bottom: 12rem !important;

      @media (max-width: $mobileBreak) {
        top: 31rem !important;
      }
      &.visible-mobile{
        top: 25rem !important;

        img{
          width: 90px;
          height: 90px;
          margin-right: -10px;
        }
      }

    }

    img {
      width: 200px;
      height: 100px;
      position: relative;
      z-index: 10;
      margin-right: -10px;
      // border-radius: 50%;
    }


  }

  .imagen-button {
    position: fixed;
    bottom: 1rem !important;
    right: 20px;
    z-index: 1000;

    &.promocion {
      bottom: 19rem !important;

      @media (max-width: $mobileBreak) {
        top: 31rem !important;
      }
    }

    img {
      width: 200px;
      height: 100px;
      position: relative;
      z-index: 10;
      // border-radius: 50%;
    }


  }

  .chat-button {
    position: fixed;
    bottom: 1rem !important;
    right: 20px;
    z-index: 1000;

    &.phone {
      bottom: 7rem !important;

      @media (max-width: $mobileBreak) {
        top: 31rem !important;
      }
    }

    &:hover {
      .chat-button__label {
        opacity: 1;
        right: calc(100% - 30px);
        top: 35px !important;
      }
    }

    img {
      width: 70px;
      height: 70px;
      position: relative;
      z-index: 10;
      // border-radius: 50%;
    }

    &__label {
      position: absolute;
      width: 330px;
      background-color: #7b7c9a;
      border-radius: 100px 0 0 100px;
      right: -400px;
      padding: 12px 40px 12px 25px;
      transform: translateY(-50%);
      top: 50% !important;
      color: #fff;
      box-shadow: 0 0 10px rgba(0, 0, 0.2);
      transition: 300ms;
      opacity: 0;
    }

    @media (max-width: 479px) {
      bottom: 80px !important;
    }
  }

  &__section-subscribe {
    padding: 30px;
    background: #173b71 0 0 no-repeat padding-box;

    form {
      display: flex;
      justify-content: center;

      .form-group {
        display: flex;
        align-items: center;
        justify-content: center;

        @media (max-width: $mobileBreak) {
          flex-wrap: wrap;
        }

        .form-control {
          font-size: 15px;
          width: 30rem;
          padding: 10px 15px 10px 20px;
          border-top-right-radius: 0px;
          border-bottom-right-radius: 0px;
          border: 1px solid $primaryPink;
          transition: 0.3s;

          @media (max-width: $mobileBreak) {
            width: 100%;
            border-radius: 0px;
          }

          &:focus {
            outline: none;
            box-shadow: none;
            padding-left: 25px;
          }

          &::placeholder {
            color: $thirdGray;
            transition: 0.3s;
          }

          &:focus::placeholder {
            padding-left: 5px;
          }
        }

        .form-btn {
          font-family: $firstFont;
          font-weight: 500;
          width: 14rem;
          height: 45px;
          margin-left: -10px;
          font-size: 14px;
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
          border: none;
          color: white;
          background-color: $primaryPink;
          transition: 0.3s;

          &:disabled {
            width: 5rem;
            background-color: $primaryGray;
          }

          @media (max-width: $mobileBreak) {
            width: 100%;
            margin: 10px 0px 0px 0px;
            border-radius: 0px;
          }
        }
      }
    }

    &__success {
      margin-top: 5px;

      span {
        display: block;
        width: 100%;
        text-align: center;
        font-weight: 500;
        color: $success;
      }
    }
  }

  &__footer {
    padding: 35px 0px;
    background-color: $primaryBlue;

    &__RUC {
      margin-left: 74px;
      color: #fff;
      font-size: 18px;
      line-height: 20.7px;
      font-weight: 400;

      @media (max-width: $mobileBreak) {
        font-size: 14px;
        text-align: left;
        margin: 0 0 0 40px;
      }
    }

    hr {
      margin: 25px 0px;
      color: white;
      opacity: 1;
      border-width: thin;
    }

    @media (max-width: $mobileBreak) {
      .col-sm {
        padding: 0;
      }

      hr {
        margin: 0px 15px;
      }
    }

    .container {
      @media (min-width: $desktopBreak) {
        padding: 0 !important;
      }
    }

    &__section {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin-left: 74px;
      margin-top: 30px;

      @media (max-width: $mobileBreak) {
        justify-content: space-between;
        margin-left: 40px;
      }

      a {
        display: block;
        color: white;
        font-size: 18px;
        text-decoration: none;
        margin: 0px 15px 0px 0px;

        @media (max-width: $mobileBreak) {
          font-size: 14px;
        }

        &:hover {
          color: white;
        }
      }

      &__carousel-card2 {
        background-color: red !important;
      }
    }

    &__logo {
      text-align: right;
      margin-right: 50px;

      .libro {
        margin-top: 15px;
      }

      @media (max-width: $mobileBreak) {
        justify-content: center;
        margin: 5px 0px;
        ;

        span {
          display: block;
          font-size: 14px;
          margin: 0px 12px 0px 0px;
          color: white;
        }

      }

    }
  }
}

.login-modal {

  .modal-header,
  .modal-footer {
    display: none;
  }

  .modal-sm {
    @media (min-width: $desktopBreak) {
      width: 400px !important;
      max-width: 400px;
    }
  }

  .modal-content {
    border-radius: 25px !important;
  }

  .quote-card {
    width: 100%;
    padding: 15px;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
    background-color: white;

    form {
      .form-group {
        font-family: $firstFont;
        font-weight: 400;
        font-size: 14px;
        position: relative;
        display: flex;
        align-items: center;
        margin: 0px 15px 12px 0px;

        .error {
          display: none;
        }

        &.invalid {
          display: block;

          .error {
            font-weight: 600;
            font-size: 13px;
            display: block;
            text-align: left;
            margin: 2px 0px 0px 10px;
            color: $primaryRed;
            width: 100%;
          }
        }

        &.type-radio {
          input[type="radio"] {
            margin-right: 14px;
          }

          input[type="radio"]::after {
            content: "";
            position: absolute;
            z-index: 5;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            cursor: pointer;
            background-color: transparent;
          }

          input[type="radio"]:checked~label::before {
            background-color: $primaryBlue;
          }

          input[type="radio"]:checked~label::after {
            border: 1px solid $primaryBlue;
          }

          label::before {
            content: "";
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            width: 19px;
            height: 19px;
            border-radius: 50%;
            background-color: white;
            cursor: pointer;
            transition: 0.3s;
          }

          label::after {
            content: "";
            position: absolute;
            z-index: 1;
            top: 0;
            left: 0;
            width: 19px;
            height: 19px;
            border-radius: 50%;
            border: 1px solid #d8d6de;
            cursor: pointer;
            transition: 0.3s;
          }
        }

        //

        .form-control {
          font-family: $firstFont;
          font-weight: 400;
          width: 100%;
          margin-top: 12px;
          padding: 10px;
          text-align: center;
          outline: none;
          border-radius: 5px !important;
          border: 1px solid #d8d6de;
          transition: 0.3s;
        }

        .form-control::placeholder {
          color: #c2c2c2;
        }

        .form-control:focus {
          border: 1px solid $primaryPurple;
          padding-left: 20px;
          box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.1);
        }

        //

        .form-btn {
          font-family: $firstFont;
          font-weight: 500;
          font-size: 17px;
          width: 100%;
          border-radius: 5px;
          padding: 13px;
          border: none;
          color: white;
          background-color: $primaryPink;
        }

        //

        h6 {
          font-weight: 500;
          font-size: 18px;
          width: 100%;
          display: block;
          text-align: center;
          color: $primaryBlue;
          margin: 0;
        }

        p {
          font-size: 14px;
          margin: 0;
          padding-right: 10px;
        }

        img {
          width: 100px;
        }

        span {
          display: block;
          text-align: center;
          width: 100%;

          a {
            font-weight: 500;
            color: $primaryBlue;
          }
        }
      }
    }
  }
}

.modal-no-insurance {
  &__head {
    color: $primaryBlue;
    text-align: center;
    margin: 0px 0px 30px 0px;

    h3 {
      font-weight: 600;
      font-size: 22px;

      br {
        display: none;
      }
    }

    p {
      margin: 15px 0px 20px 0px;
    }
  }

  button {
    width: 130px !important;
    height: 30px !important;
    font-size: 18px !important;
    background-color: #0855c4;
    color: #ffffff;
    width: 85px;
    height: 20px;
    font-size: 13px;
    border: none;
    outline: none;
    border-radius: 5px;
  }

  .modal-content {
    padding: 30px 20px 15px 20px;
    border-radius: 40px !important;
    background-color: #ffffff !important;

    .modal-header {
      display: none !important;
    }

    .modal-footer {
      display: none;
    }
  }
}

.modal-no-insurance {
  .modal-dialog {
    .modal-content {
      background-color: $mainColor;

      .modal-header {
        display: none !important;
      }

      .modal-footer {
        justify-content: center;
        padding-bottom: 20px;

        .btn {
          background-color: #fff !important;
          color: $mainColor !important;
        }
      }
    }
  }
}

/**COOKIES */
.homeView-cookies {
  position: fixed;
  width: 100%;
  bottom: 0;
  background-color: #fff;
  z-index: 100;
  box-shadow: 10px 22px 1px 5px rgba(0, 0, 0, 0.8);
  border-top: 1px solid #e3e3e3;

  @media (max-width: 1366px) {
    background-color: #fff !important;
  }

  .card {
    padding-left: 170px;
    border: none !important;
    border-radius: 0px !important;

    @media (max-width: 479px) {
      padding: 0px 20px 0 20px !important;
    }

    @media (max-width: 479px) {
      padding: 0px 20px 0 20px !important;
    }
  }

  .buttons {
    padding-left: 50px;

    @media (max-width: 1366px) {
      padding-left: 30px !important;
    }
  }

  &__title {
    color: #383838;
    font-size: 18px;
    font-weight: 600;
    padding-bottom: 8px;
    padding-top: 3px;
  }

  &__text {
    color: #191919;
    font-size: 16px;
    line-height: 18px;

    @media (max-width: 479px) {
      font-size: 14px !important;
    }
  }

  &__btn-config {
    @media (max-width: 479px) {
      padding-left: 0px !important;
      justify-content: center !important;
      padding-bottom: 10px !important;
      display: flex !important;
    }

    button {
      border-color: #0d5aea !important;
      color: #0d5aea;
      font-size: 18px;
      background-color: #fff;
      box-shadow: none !important;
      font-weight: 600;
      width: 215px;
      height: 52px;

      @media (max-width: 479px) {
        width: 215px !important;
        height: 34px !important;
        display: flex;
        align-items: center !important;
        text-align: center !important;
        justify-content: center !important;
        margin: 0px !important;
        padding: 0px !important;
      }
    }

    button:hover {
      background-color: #fff !important;
      color: #0d5aea;
    }
  }

  &__btn-aceptar {
    padding-left: 34px;

    @media (max-width: 1366px) {
      padding-left: 22px !important;
      justify-content: center !important;
      padding-bottom: 10px !important;
      display: flex !important;
    }

    @media (max-width: 479px) {
      padding-left: 0px !important;
      text-align: center !important;
    }

    button {
      border-color: #ea0f8f !important;
      color: #ffffff;
      font-size: 18px;
      background-color: #ea0f8f;
      box-shadow: none !important;
      font-weight: 600;
      width: 215px;
      height: 52px;

      @media (max-width: 479px) {
        width: 215px !important;
        height: 34px !important;
        display: flex;
        align-items: center !important;
        text-align: center !important;
        justify-content: center !important;
        margin: 0px !important;
        padding: 0px !important;
      }
    }

    button:hover {
      background-color: #ea0f8f !important;
      color: #ffffff;
    }
  }
}

//COOKIES-MODAL

.cookies {
  width: 80%;

  .modal-header {
    display: none !important;
  }

  .modal-content {
    border-radius: 0px !important;
    padding: 70px 58px 0px 58px;

    @media (max-width: 1366px) {
      padding: 15px 8px 0px 8px !important;
    }
  }

  .modal-dialog {
    max-width: 100% !important;
    padding-left: 250px !important;
    padding-right: 220px !important;

    @media (max-width: 1366px) {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }

  .modal-footer {
    display: none !important;
  }

  &__head {
    width: 100%;

    p {
      color: #2f2f2f;
      font-size: 18px;

      @media (max-width: 1366px) {
        font-size: 15px !important;
      }
    }

    b {
      font-weight: 500 !important;
      font-size: 18px;
      color: #2f2f2f;

      @media (max-width: 1366px) {
        font-size: 15px !important;
      }
    }

    &__title {
      color: #2f2f2f;
      font-size: 18px;
      font-weight: 600;

      @media (max-width: 1366px) {
        font-size: 15px !important;
      }
    }
  }

  .cookies-buttons {
    margin-top: 120px;
    margin-bottom: 50px;
  }

  &__btn-aceptar {
    padding-left: 34px;

    @media (max-width: 1366px) {
      padding-left: 22px !important;
      justify-content: center !important;
      padding-bottom: 10px !important;
      display: flex !important;
      padding-bottom: 48px !important;
    }

    @media (max-width: 479px) {
      padding-left: 0px !important;
      text-align: center !important;
    }

    button {
      border-color: #ea0f8f !important;
      color: #ffffff;
      font-size: 18px;
      background-color: #ea0f8f;
      box-shadow: none !important;
      font-weight: 600;
      width: 305px;
      height: 52px;

      @media (max-width: 479px) {
        width: 235px !important;
        height: 34px !important;
        display: flex;
        align-items: center !important;
        text-align: center !important;
        justify-content: center !important;
        margin: 0px !important;
        padding: 0px !important;
      }
    }

    button:hover {
      background-color: #ea0f8f !important;
      color: #ffffff;
    }
  }

  &__btn-config {
    @media (max-width: 479px) {
      padding-left: 0px !important;
      justify-content: center !important;
      padding-bottom: 10px !important;
      display: flex !important;
      padding-top: 48px !important;
    }

    button {
      border-color: #0d5aea !important;
      color: #0d5aea;
      font-size: 18px;
      background-color: #fff;
      box-shadow: none !important;
      font-weight: 600;
      width: 305px;
      height: 52px;

      @media (max-width: 479px) {
        width: 235px !important;
        height: 34px !important;
        display: flex;
        align-items: center !important;
        text-align: center !important;
        justify-content: center !important;
        margin: 0px !important;
        padding: 0px !important;
      }
    }

    button:hover {
      background-color: #fff !important;
      color: #0d5aea;
    }
  }
}

.carousel-content {
  position: relative;
  height: 550px;
  margin-top: 55px;
  padding-top: 230px;

  &__form {
    position: relative;
    z-index: 100;
    width: 685px;

    @media (max-width: 1366px) {
      width: 500px;
    }

    .cuadro {
      border-radius: 12px 0px;
      background: #0855c4;
      width: 156px;
      height: 46px;
      position: absolute;
      top: -24px;
      right: 20px;

      .desde {
        color: #fff;
        font-size: 25px;
        font-style: normal;
        font-weight: 300;
        line-height: 120%;
        padding-right: 7px;
      }

      .quantity {
        color: #fff;
        font-size: 25px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%;
      }
    }

    .home__quote-card {
      box-shadow: rgba(69, 74, 108, 0.08) 0px 4px 16px 0px;
      margin-top: -57px;
    }
  }

  @media (max-width: 1366px) {
    height: 450px !important;
  }
}

.carousel-content-mobile {
  .home__quote-card {
    position: relative;
    margin-top: -15px;

    .cuadro {
      z-index: 100;
    }
  }
}
.custom-cintillo-background {
  height: auto;
  width: 100%;
  background: linear-gradient(270deg, #03BBFF 0%, #03BBFF 26.86%);

  @media (min-width: $size-tablet) {
    background: linear-gradient(270deg, #03BBFF 0%, #03BBFF 26.86%);
  }
}

.custom-folleto-background {
  height: auto;
  width: 100%;
  margin-bottom: 1.5rem;
}

.custom-cintillo-container {
  width: 100%;
  max-width: $size-mobile;
  margin-right: auto;
  margin-left: auto;
  margin-top: 1.25rem;
  position: relative;

  &--endosos {
    margin-top: 1.25rem !important;

    @media (min-width: $size-mobile) {
      margin-top: 2.5rem !important;
    }
  }

  @media (min-width: $size-mobile) {
    max-width: $size-mobile;
  }

  @media (min-width: $size-tablet) {
    max-width: $size-desktop;
    margin-top: 0;
  }

  @media (min-width: $size-desktop) {
    max-width: $size-desktop;
    //padding: 0 $container-lg;
   // width: $size-desktop;
  }
}

.custom-cintillo {
  /*display: inline-flex;*/
  width: 100%;
  position: relative;

  &--mobile {
    display: block;
    @media (min-width: $size-tablet) {
      display: none;
    }
  }

  &--desktop {
    display: none;
    @media (min-width: $size-tablet) {
      display: block;
    }
  }

  &__cintillo {
    width: 100%;
    height: 100%;
  }

  &__campaign-timer {
    position: absolute;
    top: 50%;
    right: 2%;
    transform: translateY(-50%);

    @media (min-width: $size-tablet) {
      right: 4%;
    }

    &__title {
      color: $color-white;
      font-family: $font-omnes-medium;
      font-size: 0.875rem;
      line-height: 1.1;

      @media (min-width: $size-tablet) {
        font-size: 0.8125rem;
        font-family: $font-omnes-regular;
      }
    }
  }
}

</style>
